import { Icon, Image } from "components";
import { convertDate } from "helpers";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { PersonDetailsContext } from ".";

export default function AboutMe() {
  const { user, linksRoom, isBusinessProfile } =
    useContext(PersonDetailsContext);
  const hasAboutMe = !!user.aboutMe;
  const hasDateOfBirth = !!user.dateOfBirth;
  const album = user.album ?? [];
  // const hasAlbum = !!album.length;
  const hasAlbum = !!album.length;
  const AlbumComponent = hasAlbum ? Link : "div";
  return (
    <section className="px-5 space-y-5">
      <article className="space-y-2">
        <h2 className="text-base text-[#353740] font-medium">About me</h2>
        {hasAboutMe && (
          <p className="text-sm text-[#5E6278] font-normal">{user.aboutMe}</p>
        )}
        {hasDateOfBirth && (
          <p className="text-sm text-[#5E6278] font-medium">
            <Icon
              name={isBusinessProfile ? "Calendar2" : "CalendarTick"}
              className="size-6 text-primary"
            />{" "}
            {convertDate(
              user.dateOfBirth,
              isBusinessProfile ? "day-month-year" : "default",
            )}
          </p>
        )}
      </article>
      <hr />
      <article className="space-y-5">
        <h2 className="text-base text-[#353740] font-medium">My links room</h2>
        <p className="text-sm text-[#5E6278] font-medium">
          <Icon name="LinkCircle" className="size-6 text-primary" /> {linksRoom}
        </p>
      </article>
      <hr />
      <article className="space-y-4">
        <h2 className="text-base text-[#353740] font-medium">My album</h2>
        <div className="grid grid-cols-3 grid-rows-4 gap-1">
          {[0, 1, 2, 3, 5, 4].map((index) => {
            const img = user.album?.find((e) => e.displayOrder === index);
            return (
              <AlbumComponent
                key={index}
                to={{
                  pathname: "gallery",
                  search: img?.id ? `id=${img?.id}` : undefined,
                }}
                state={album}
                className="w-full aspect-image rounded first:col-span-2 first:row-span-2 [&:nth-child(5)]:col-span-2 [&:nth-child(5)]:row-span-2 overflow-hidden"
              >
                <Image
                  src={img?.thumbnailUrl}
                  alt={[user.firstName, user.lastName].join(" ")}
                  className="size-full object-cover"
                />
              </AlbumComponent>
            );
          })}
        </div>
      </article>
    </section>
  );
}
